<template>
  <div>
  <el-dialog title="添加" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <el-form-item label="手机号码" prop="mobile" :label-width="formLabelWidth">
        <el-input v-model="formData.mobile" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="等级id" prop="grade_id" :label-width="formLabelWidth">
        <el-input v-model="formData.grade_id" placeholder="请输入"></el-input>
      </el-form-item>

      <!--是否显示-->
      <el-form-item label="是否显示" prop="status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">有效</el-radio>
          <el-radio :label="0">无效</el-radio>
        </el-radio-group>
      </el-form-item>

    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
  </div>
</template>

<script>
import ImportUserApi from '@/api/study/import_user.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        mobile: '',
        grade_id: '',
        status: 1,
      },
      /*验证规则*/
      formRules: {
        mobile: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        grade_id: [{ required: true, message: '请输入等级id', trigger: 'blur' }],
      },
      /*排序*/
      srot: '1',
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: {
    open_add: Boolean,
    selectModel: Object,
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          ImportUserApi.add(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/importuser/user/part/Add.vue